import { render, staticRenderFns } from "./MergeInvestigationPopup.vue?vue&type=template&id=14b66900&scoped=true"
import script from "./MergeInvestigationPopup.vue?vue&type=script&lang=js"
export * from "./MergeInvestigationPopup.vue?vue&type=script&lang=js"
import style0 from "./MergeInvestigationPopup.vue?vue&type=style&index=0&id=14b66900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b66900",
  null
  
)

export default component.exports